import { CatListItem } from '@blocks-react/components/ListItem';
import { FC } from 'react';
import cx from 'classnames';
import { Conditional, TextHighlight } from '../../../common';
import styles from './HeaderSearchBarSuggestion.module.scss';
import { HeaderSearchBarSuggestionProps } from './types';
import { normalizeCommerceLink } from '../../../common/utils';
import { HEADLESS_CATEGORY_PAGE_BASE_PATH } from '../../../common/constants';

export const HeaderSearchBarSuggestion: FC<HeaderSearchBarSuggestionProps> = ({
  items,
  label,
  highlightText = '',
  onItemClick,
  imgComp: Image = 'img',
  isHeadlessCategoryEnabled,
  seoURL = ''
}) => (
  <Conditional test={items.length > 0}>
    <CatListItem isStatic>
      <p
        className={cx(
          styles['header__search-bar-suggestion-label'],
          'text-capitalize my-auto'
        )}
      >
        {label}
      </p>
    </CatListItem>
    {items.map(({ displayName, name, value, imageURL, seoUrlKeyword = '' }) => {
      const itemName = name ?? displayName;

      const pccCategoryURL = normalizeCommerceLink(
        `${seoURL}/${seoUrlKeyword}`
      );
      const headlessCategoryURL = `${seoURL}/${HEADLESS_CATEGORY_PAGE_BASE_PATH}/${seoUrlKeyword}`;

      const categoryURL = isHeadlessCategoryEnabled
        ? headlessCategoryURL
        : pccCategoryURL;

      const suggestionURL = seoUrlKeyword ? categoryURL : value;

      return (
        <CatListItem
          href={suggestionURL}
          data-testid={itemName}
          key={`${itemName}${value}`}
          value={itemName}
          onClick={() => onItemClick(itemName)}
        >
          <Conditional test={!!imageURL}>
            <Image
              slot="before"
              loading="lazy"
              height={48}
              width={48}
              className={styles['header__search-bar-suggestion-image']}
              alt={itemName}
              src={`${imageURL}&wid=48&hei=48&fmt=png-alpha`}
            />
          </Conditional>
          <TextHighlight text={itemName} textToHighlight={highlightText} />
        </CatListItem>
      );
    })}
  </Conditional>
);
